import { useCallback } from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid, Container, CircularProgress } from "@mui/material";
import { ExampleQuestionCard } from "./example-question-card";
import { body1ResponsiveSizes } from "../../../shared/styles/custom-styles";
import { HandleSendType } from "../../chat";
import { useSettings } from "../../settings";
import { RecommendedPrompt } from "../../settings/types";

type ChatIntroProps = {
  handleSend: HandleSendType;
};

export const ChatIntro = ({ handleSend }: ChatIntroProps) => {
  const { recommendedPrompts } = useSettings();
  const handleCardClick = useCallback(
    (prompt: RecommendedPrompt) => {
      handleSend(false, prompt.user_prompt_fe, prompt.user_prompt_be);
    },
    [handleSend]
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        mt: "5vh",
      }}
    >
      <Typography
        variant="h4"
        component="h2"
        gutterBottom
        sx={{
          color: "text.secondary",
        }}
      >
        Hello, welcome to Conversational AI! 👋🤖
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mt: 2,
          color: "text.secondary",
          textAlign: "center",
          fontSize: body1ResponsiveSizes,
        }}
      >
        Feel free to ask any questions about your data.
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mt: 2,
          textAlign: "center",
          color: "text.secondary",
          fontSize: body1ResponsiveSizes,
        }}
      >
        Example questions you might consider:
      </Typography>
      {recommendedPrompts.length === 0 && (
        <CircularProgress size={24} sx={{ m: 10 }} />
      )}
      <Container sx={{ display: "flex", justifyContent: "center" }}>
        <Grid container spacing={2} justifyContent="center" sx={{ mt: 1 }}>
          {recommendedPrompts.map((prompt, index) => (
            <ExampleQuestionCard
              key={index}
              prompt={prompt}
              handleCardClick={handleCardClick}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
